import styled from 'styled-components';

export const TransparentButton = styled.button`
  background: transparent;
  outline: none;
  border: none;
  color: #d2dded;
  font-size: 20px;
`;
